import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '../../common/Input'
import { Button } from '../../common/Button'
import { StepHeader } from '../StepHeader'
import { validateOptionalEmail } from '../../../services/validation'

interface LovedOneEmailStepProps {
  initialValue?: string
  onNext: (value: string) => void
  onBack: () => void
  onSkip: () => void
}

/**
 * Loved one email collection (optional) (FR-013, FR-014)
 */
export function LovedOneEmailStep({
  initialValue = '',
  onNext,
  onBack,
  onSkip,
}: LovedOneEmailStepProps) {
  const { t } = useTranslation()
  const [email, setEmail] = useState(initialValue)
  const [error, setError] = useState('')

  const handleNext = () => {
    const validation = validateOptionalEmail(email)

    if (!validation.isValid) {
      setError(validation.error || t('errors.invalidEmail'))
      return
    }

    onNext(email.trim())
  }

  return (
    <div>
      <StepHeader type="loved-one" title="What is their email? (Optional)" />

      <Input
        label={t('onboarding.lovedOne.emailLabel')}
        placeholder={t('onboarding.lovedOne.emailPlaceholder')}
        type="email"
        value={email}
        onChange={e => {
          setEmail(e.target.value)
          if (error) setError('')
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            handleNext()
          }
        }}
        error={error}
        helpText={t('onboarding.lovedOne.emailHelp')}
        autoFocus
      />

      <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem', flexWrap: 'wrap' }}>
        <Button variant="outline" onClick={onBack} style={{ flex: '1 1 150px' }}>
          {t('onboarding.navigation.back')}
        </Button>
        <Button variant="secondary" onClick={onSkip} style={{ flex: '1 1 150px' }}>
          {t('onboarding.navigation.skip')}
        </Button>
        <Button onClick={handleNext} style={{ flex: '1 1 150px' }}>
          {t('onboarding.navigation.next')}
        </Button>
      </div>
    </div>
  )
}
